import { SelectOption } from '@common/types/common';
import {
    FormControl,
    FormControlProps,
    MenuItem as MuiMenuItem,
    Select as MuiSelect,
    SelectProps,
    styled,
} from '@mui/material';
import { useState } from 'react';

interface IDropdownProps {
    items: (SelectOption<string | number> & {
        icon?: React.FunctionComponent<
            React.SVGProps<SVGSVGElement> & {
                title?: string;
            }
        >;
    })[];
    value?: SelectProps['value'];
    onChange?: SelectProps['onChange'];
}

interface IDropdownFormControlProps extends FormControlProps {
    open?: boolean;
}

const DropdownFormControl = ({ children, ...fcProps }: IDropdownFormControlProps) => (
    <FormControl {...fcProps}>{children}</FormControl>
);

export const StyledDropdownFormControl = styled(DropdownFormControl)(({ theme, open }) => ({
    backgroundColor: theme.palette['primary-600'].main,
    borderRadius: open ? '0.75rem 0.75rem 0 0' : '0.75rem',
    '& .MuiInputBase-root': {
        backgroundColor: theme.palette['primary-600'].main,
        borderRadius: open ? '0.75rem 0.75rem 0 0' : '0.75rem',
    },
    '& .MuiInputBase-root:hover': {
        backgroundColor: theme.palette['primary-600'].main,
    },
}));

const DropdownSelect = styled(MuiSelect)({
    '& .MuiSelect-select': {
        padding: '0.5rem 1rem',
        color: 'inherit',
    },
    '& .MuiSvgIcon-root ': {
        fill: 'white',
    },
});

const DropdownMenuItem = styled(MuiMenuItem)({
    padding: '0.75rem 0.625rem',
    '&.MuiMenuItem-divider': {
        margin: '0 0.625rem',
    },
});

export const Dropdown = ({ value, items, onChange }: IDropdownProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    return (
        <StyledDropdownFormControl open={dropdownOpen} className="w-auto sm:w-64">
            <DropdownSelect
                value={value}
                variant="filled"
                className="text-white text-xl font-inter font-medium "
                disableUnderline
                onChange={onChange}
                onOpen={() => setDropdownOpen(true)}
                onClose={() => setDropdownOpen(false)}
            >
                {items.map((category) => (
                    <DropdownMenuItem value={category.value} key={category.value} divider>
                        {category.label}
                    </DropdownMenuItem>
                ))}
            </DropdownSelect>
        </StyledDropdownFormControl>
    );
};
